var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTx = function SvgIconTx(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 188.125,
    height: 179.907,
    viewBox: "0 0 188.125 179.907",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_713",
    "data-name": "Rectangle 713",
    width: 188.125,
    height: 179.907,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891",
    transform: "translate(4 5.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890",
    transform: "translate(-4 -5.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M102.183,15.829h-37.9L62.909,86.387l-46.939-1.7s-.636,1.993.8,2.971,3.989,5.589,6.728,7.068,6.265,7.451,9.925,9.411,5.22,3.753,6.1,8.314,1.288,9.36,5.8,12.09S57.032,134,60.6,133.371s4.642-6.279,5.417-8.116,2.856-4.759,9.117-4.408,9.694,1.5,14.461,5.44,13.37,22.722,17.25,25.682,2.963,3.97,5.162,9.871,2.963,9.488,8.01,11.443,9.056,4.832,12.032,4.66,4.519-.655,7,1.021,2.715,1.621,4.438.811,1.215-3.652-.3-10.136-3.712-16.855,5.624-24.343,17.432-12.96,22.131-16.084,3.541-6.061,8.748-7.948,7.927-1.24,7.782-3.067-2.387-2.2-.225-4.619,1.249-5.716,1.186-7.727,3.326-6.833-.163-12.447-2.42-7.284-4.319-9.113-2.067-1.023-2.48-6.34-.809-20.135-2.723-19.868-4.86-.577-7.531-1.616-4.018-3.2-7.842-2.926-8.278.831-10.492,2.233a9.028,9.028,0,0,1-8.006.228c-2.117-1.1-2.895-2.395-3.653-.514s-5.458-.558-7.65-.848-3.647,2.137-4.51.316-1.8-2.621-3.879-2.712-6.534.134-8.259-.349-3.563-3.052-5.082-3.509-8.864-.22-8.982-2.277S102.183,15.829,102.183,15.829Z",
    transform: "translate(-8.778 -7.469)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTx);
export { ForwardRef as ReactComponent };